import { render, staticRenderFns, recyclableRender, components } from "./comment-and-thumbsup.vue?vue&type=template&id=5b2f3c0b&scoped=true&"
var renderjs
import script from "./comment-and-thumbsup.vue?vue&type=script&lang=js&"
export * from "./comment-and-thumbsup.vue?vue&type=script&lang=js&"
import style0 from "./comment-and-thumbsup.vue?vue&type=style&index=0&id=5b2f3c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f3c0b",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/square/comment-and-thumbsup.vue"
export default component.exports